const EcoCartMinus: React.FC = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none">
        <rect x="9.89014" y="15.7778" width="12.9869" height="1.44444" rx="0.722222" fill="currentColor" />
    </svg>
);

export default EcoCartMinus;
